import { initializeApp, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { firebaseConfig } from "./config";

/**
 * Secondary Firebase Auth Instance
 * Used to provision secondary accounts (e.g., Caregivers) without 
 * disrupting the primary user's active session.
 */
let secondaryApp;
try {
  secondaryApp = getApp("SecondaryAuthNode");
} catch (e) {
  secondaryApp = initializeApp(firebaseConfig, "SecondaryAuthNode");
}

export const secondaryAuth = getAuth(secondaryApp);
